import { Constants } from "./constants";

export class Book {



    public activeDays: Number = 0;
    public author: String = "";
    public bookType: Number = 0;
    public clientId: String = "";
    public storeId: String = "";
    public coverPage: String = "";
    public templateId: String = "";
    // public templateType:Number =0;//0 for standard 1 for custom
    public bookCategory: Number = 0;
    public description: String = "";
    public downloadUrl: String = "";
    public price: Number = 0;
    public language: String = "";
    public title: String = "";
    public pageCount: any = 1;
    public bId: any = 0;
    public owner: String = Constants.USER;
    public bookDataDocId: String = "Not Defined";
    public type: String = "book";
    public _id: String = "";
    public isFavorite: boolean = false;
    public isCustomTemplate: boolean = false;
    public url: String = "";
    public reference: String = "";
    public lastOpenedPage: String = "0";
    public downloadThumbnailUrl: string = "";
    public isDownloading: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/book.ts